/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApplicationFeature } from '../models';
// @ts-ignore
import type { EntityType } from '../models';
// @ts-ignore
import type { FileMetaDataDto } from '../models';
// @ts-ignore
import type { SystemUploadMetadataDto } from '../models';
// @ts-ignore
import type { UploadedFileFeature } from '../models';
// @ts-ignore
import type { UploadedFileInfoModel } from '../models';
/**
 * AbstractFileStorageApi - axios parameter creator
 * @export
 */
export const AbstractFileStorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SystemUploadMetadataDto} systemUploadMetadataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abstractFileStorageControllerCreateSystemUploadMetaData: async (systemUploadMetadataDto: SystemUploadMetadataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemUploadMetadataDto' is not null or undefined
            assertParamExists('abstractFileStorageControllerCreateSystemUploadMetaData', 'systemUploadMetadataDto', systemUploadMetadataDto)
            const localVarPath = `/api/abstract-file-storage/system-upload/metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemUploadMetadataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} filePath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abstractFileStorageControllerDeleteUserFile: async (filePath: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filePath' is not null or undefined
            assertParamExists('abstractFileStorageControllerDeleteUserFile', 'filePath', filePath)
            const localVarPath = `/api/abstract-file-storage/user-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filePath !== undefined) {
                localVarQueryParameter['filePath'] = filePath;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abstractFileStorageControllerGetFileMetaData: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('abstractFileStorageControllerGetFileMetaData', 'fileId', fileId)
            const localVarPath = `/api/abstract-file-storage/file-metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileId !== undefined) {
                localVarQueryParameter['fileId'] = fileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {string} entityId 
         * @param {EntityType} databaseEntityType Values: 0&#x3D;Company, 1&#x3D;Form, 2&#x3D;Template, 3&#x3D;DoubleMateriality
         * @param {UploadedFileFeature} uploadedFileFeature Values: csob-form-exports&#x3D;CsobFormExports, form-reports&#x3D;FormReports, form-calculation-excel&#x3D;FormCalculationExcel, form-data&#x3D;FormData, company-logo&#x3D;CompanyLogo, company-file-storage&#x3D;CompanyFileStorage
         * @param {ApplicationFeature | null} [relatedFeature] Values: 0&#x3D;CO2, 1&#x3D;ESG, 2&#x3D;CSRD, 3&#x3D;SFDR, 4&#x3D;CSOB, 5&#x3D;PROCUREMENT_BUYER, 6&#x3D;PROCUREMENT_SUPPLIER, 7&#x3D;GM_ADMIN, 8&#x3D;T_MOBILE, 9&#x3D;PROCUREMENT_SUPPLIER_T_MOBILE, 10&#x3D;PSAS, 11&#x3D;BRSR, 12&#x3D;VSME, 13&#x3D;CSOB_SK, 14&#x3D;PAYGAP, 15&#x3D;EF_MANAGEMENT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abstractFileStorageControllerUploadFile: async (file: File, entityId: string, databaseEntityType: EntityType, uploadedFileFeature: UploadedFileFeature, relatedFeature?: ApplicationFeature | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('abstractFileStorageControllerUploadFile', 'file', file)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('abstractFileStorageControllerUploadFile', 'entityId', entityId)
            // verify required parameter 'databaseEntityType' is not null or undefined
            assertParamExists('abstractFileStorageControllerUploadFile', 'databaseEntityType', databaseEntityType)
            // verify required parameter 'uploadedFileFeature' is not null or undefined
            assertParamExists('abstractFileStorageControllerUploadFile', 'uploadedFileFeature', uploadedFileFeature)
            const localVarPath = `/api/abstract-file-storage/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (entityId !== undefined) { 
                localVarFormParams.append('entityId', entityId as any);
            }
    
            if (databaseEntityType !== undefined) { 
                localVarFormParams.append('databaseEntityType', databaseEntityType as any);
            }
    
            if (uploadedFileFeature !== undefined) { 
                localVarFormParams.append('uploadedFileFeature', uploadedFileFeature as any);
            }
    
            if (relatedFeature !== undefined) { 
                localVarFormParams.append('relatedFeature', relatedFeature as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [file] 
         * @param {string} [companyId] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abstractFileStorageControllerUploadSystemFile: async (file?: File, companyId?: string, entityId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/abstract-file-storage/system-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (companyId !== undefined) { 
                localVarFormParams.append('companyId', companyId as any);
            }
    
            if (entityId !== undefined) { 
                localVarFormParams.append('entityId', entityId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbstractFileStorageApi - functional programming interface
 * @export
 */
export const AbstractFileStorageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbstractFileStorageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SystemUploadMetadataDto} systemUploadMetadataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async abstractFileStorageControllerCreateSystemUploadMetaData(systemUploadMetadataDto: SystemUploadMetadataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.abstractFileStorageControllerCreateSystemUploadMetaData(systemUploadMetadataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbstractFileStorageApi.abstractFileStorageControllerCreateSystemUploadMetaData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} filePath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async abstractFileStorageControllerDeleteUserFile(filePath: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.abstractFileStorageControllerDeleteUserFile(filePath, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbstractFileStorageApi.abstractFileStorageControllerDeleteUserFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async abstractFileStorageControllerGetFileMetaData(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileMetaDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.abstractFileStorageControllerGetFileMetaData(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbstractFileStorageApi.abstractFileStorageControllerGetFileMetaData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {string} entityId 
         * @param {EntityType} databaseEntityType Values: 0&#x3D;Company, 1&#x3D;Form, 2&#x3D;Template, 3&#x3D;DoubleMateriality
         * @param {UploadedFileFeature} uploadedFileFeature Values: csob-form-exports&#x3D;CsobFormExports, form-reports&#x3D;FormReports, form-calculation-excel&#x3D;FormCalculationExcel, form-data&#x3D;FormData, company-logo&#x3D;CompanyLogo, company-file-storage&#x3D;CompanyFileStorage
         * @param {ApplicationFeature | null} [relatedFeature] Values: 0&#x3D;CO2, 1&#x3D;ESG, 2&#x3D;CSRD, 3&#x3D;SFDR, 4&#x3D;CSOB, 5&#x3D;PROCUREMENT_BUYER, 6&#x3D;PROCUREMENT_SUPPLIER, 7&#x3D;GM_ADMIN, 8&#x3D;T_MOBILE, 9&#x3D;PROCUREMENT_SUPPLIER_T_MOBILE, 10&#x3D;PSAS, 11&#x3D;BRSR, 12&#x3D;VSME, 13&#x3D;CSOB_SK, 14&#x3D;PAYGAP, 15&#x3D;EF_MANAGEMENT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async abstractFileStorageControllerUploadFile(file: File, entityId: string, databaseEntityType: EntityType, uploadedFileFeature: UploadedFileFeature, relatedFeature?: ApplicationFeature | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedFileInfoModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.abstractFileStorageControllerUploadFile(file, entityId, databaseEntityType, uploadedFileFeature, relatedFeature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbstractFileStorageApi.abstractFileStorageControllerUploadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [file] 
         * @param {string} [companyId] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async abstractFileStorageControllerUploadSystemFile(file?: File, companyId?: string, entityId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.abstractFileStorageControllerUploadSystemFile(file, companyId, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbstractFileStorageApi.abstractFileStorageControllerUploadSystemFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AbstractFileStorageApi - factory interface
 * @export
 */
export const AbstractFileStorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbstractFileStorageApiFp(configuration)
    return {
        /**
         * 
         * @param {SystemUploadMetadataDto} systemUploadMetadataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abstractFileStorageControllerCreateSystemUploadMetaData(systemUploadMetadataDto: SystemUploadMetadataDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.abstractFileStorageControllerCreateSystemUploadMetaData(systemUploadMetadataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} filePath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abstractFileStorageControllerDeleteUserFile(filePath: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.abstractFileStorageControllerDeleteUserFile(filePath, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abstractFileStorageControllerGetFileMetaData(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileMetaDataDto> {
            return localVarFp.abstractFileStorageControllerGetFileMetaData(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} file 
         * @param {string} entityId 
         * @param {EntityType} databaseEntityType Values: 0&#x3D;Company, 1&#x3D;Form, 2&#x3D;Template, 3&#x3D;DoubleMateriality
         * @param {UploadedFileFeature} uploadedFileFeature Values: csob-form-exports&#x3D;CsobFormExports, form-reports&#x3D;FormReports, form-calculation-excel&#x3D;FormCalculationExcel, form-data&#x3D;FormData, company-logo&#x3D;CompanyLogo, company-file-storage&#x3D;CompanyFileStorage
         * @param {ApplicationFeature | null} [relatedFeature] Values: 0&#x3D;CO2, 1&#x3D;ESG, 2&#x3D;CSRD, 3&#x3D;SFDR, 4&#x3D;CSOB, 5&#x3D;PROCUREMENT_BUYER, 6&#x3D;PROCUREMENT_SUPPLIER, 7&#x3D;GM_ADMIN, 8&#x3D;T_MOBILE, 9&#x3D;PROCUREMENT_SUPPLIER_T_MOBILE, 10&#x3D;PSAS, 11&#x3D;BRSR, 12&#x3D;VSME, 13&#x3D;CSOB_SK, 14&#x3D;PAYGAP, 15&#x3D;EF_MANAGEMENT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abstractFileStorageControllerUploadFile(file: File, entityId: string, databaseEntityType: EntityType, uploadedFileFeature: UploadedFileFeature, relatedFeature?: ApplicationFeature | null, options?: RawAxiosRequestConfig): AxiosPromise<UploadedFileInfoModel> {
            return localVarFp.abstractFileStorageControllerUploadFile(file, entityId, databaseEntityType, uploadedFileFeature, relatedFeature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [file] 
         * @param {string} [companyId] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abstractFileStorageControllerUploadSystemFile(file?: File, companyId?: string, entityId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.abstractFileStorageControllerUploadSystemFile(file, companyId, entityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AbstractFileStorageApi - object-oriented interface
 * @export
 * @class AbstractFileStorageApi
 * @extends {BaseAPI}
 */
export class AbstractFileStorageApi extends BaseAPI {
    /**
     * 
     * @param {SystemUploadMetadataDto} systemUploadMetadataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbstractFileStorageApi
     */
    public abstractFileStorageControllerCreateSystemUploadMetaData(systemUploadMetadataDto: SystemUploadMetadataDto, options?: RawAxiosRequestConfig) {
        return AbstractFileStorageApiFp(this.configuration).abstractFileStorageControllerCreateSystemUploadMetaData(systemUploadMetadataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} filePath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbstractFileStorageApi
     */
    public abstractFileStorageControllerDeleteUserFile(filePath: string, options?: RawAxiosRequestConfig) {
        return AbstractFileStorageApiFp(this.configuration).abstractFileStorageControllerDeleteUserFile(filePath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbstractFileStorageApi
     */
    public abstractFileStorageControllerGetFileMetaData(fileId: string, options?: RawAxiosRequestConfig) {
        return AbstractFileStorageApiFp(this.configuration).abstractFileStorageControllerGetFileMetaData(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} file 
     * @param {string} entityId 
     * @param {EntityType} databaseEntityType Values: 0&#x3D;Company, 1&#x3D;Form, 2&#x3D;Template, 3&#x3D;DoubleMateriality
     * @param {UploadedFileFeature} uploadedFileFeature Values: csob-form-exports&#x3D;CsobFormExports, form-reports&#x3D;FormReports, form-calculation-excel&#x3D;FormCalculationExcel, form-data&#x3D;FormData, company-logo&#x3D;CompanyLogo, company-file-storage&#x3D;CompanyFileStorage
     * @param {ApplicationFeature | null} [relatedFeature] Values: 0&#x3D;CO2, 1&#x3D;ESG, 2&#x3D;CSRD, 3&#x3D;SFDR, 4&#x3D;CSOB, 5&#x3D;PROCUREMENT_BUYER, 6&#x3D;PROCUREMENT_SUPPLIER, 7&#x3D;GM_ADMIN, 8&#x3D;T_MOBILE, 9&#x3D;PROCUREMENT_SUPPLIER_T_MOBILE, 10&#x3D;PSAS, 11&#x3D;BRSR, 12&#x3D;VSME, 13&#x3D;CSOB_SK, 14&#x3D;PAYGAP, 15&#x3D;EF_MANAGEMENT
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbstractFileStorageApi
     */
    public abstractFileStorageControllerUploadFile(file: File, entityId: string, databaseEntityType: EntityType, uploadedFileFeature: UploadedFileFeature, relatedFeature?: ApplicationFeature | null, options?: RawAxiosRequestConfig) {
        return AbstractFileStorageApiFp(this.configuration).abstractFileStorageControllerUploadFile(file, entityId, databaseEntityType, uploadedFileFeature, relatedFeature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [file] 
     * @param {string} [companyId] 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbstractFileStorageApi
     */
    public abstractFileStorageControllerUploadSystemFile(file?: File, companyId?: string, entityId?: string, options?: RawAxiosRequestConfig) {
        return AbstractFileStorageApiFp(this.configuration).abstractFileStorageControllerUploadSystemFile(file, companyId, entityId, options).then((request) => request(this.axios, this.basePath));
    }
}

